import apiClient, { type PagedResponse } from '../../client'
import type { LookupItem, UpdateLookupRequest } from '../../models/maestros.models'

const BASE_PATH = '/maestros/motivos-pausa'

export const motivosPausaService = {
  async getAll(params?: {
    page?: number
    pageSize?: number
    search?: string
  }): Promise<PagedResponse<LookupItem>> {
    return apiClient.get<PagedResponse<LookupItem>>(BASE_PATH, params)
  },
  async update(id: number, data: UpdateLookupRequest): Promise<LookupItem> {
    return apiClient.put<LookupItem, UpdateLookupRequest>(`${BASE_PATH}/${id}`, data)
  },
}
